import { useTranslation } from '@rhino-project/core/i18n';
import { useRootPath } from '@rhino-project/core/hooks';
import { Link } from '@tanstack/react-router';
import { Typography } from '@heroui/react';
import { useBaseOwnerPath } from '../../hooks';

export const NotFoundPage = () => {
  const { t } = useTranslation();
  const { build } = useBaseOwnerPath();
  const rootPath = useRootPath();
  return (
    <div>
      <Typography.Heading level={4}>
        {t('rhino.frontend.messages.404_page_not_found')}
      </Typography.Heading>
      <Link to={build(rootPath)}>
        {' '}
        {t('rhino.frontend.messages.go_back_to_homepage')}
      </Link>
    </div>
  );
};
